import React, { useState } from 'react';
import AnchorsLogoOptions from './AnchorsLogoOptions';
import MetasComponent from './MetasComponent';

import { TableProposals } from './TableProposals';

// const originUpdateInfo = {
//   BoxPropostasAprovadas: 'propostas-aprovadas',
//   BoxPropostasRecusadas: 'propostas-recusadas',
//   BoxPropostasPendentes: 'propostas-pendentes',
//   BoxTerceiroAguardandoAprovacaoRede: 'propostas-aprovadas',
//   BoxTerceiroAguardandoContratoFornecedor: 'propostas-aprovadas',
//   BoxTerceiroAguardando: 'propostas-aprovadas'
// }

function OperationsLeftContent({
  anchors,
  setAtualizaAbatimentoDesconto,
  atualizarAbatimentoDesconto,
  handleSelectAnchor,
  selectedAnchor,
  reloadPage,
  setUpdateRightTable,
  updateContent,
  updateInfo,
  setUpdateInfo,
  reloadRightTable,
  loadingRight,
  boxOperacoes
}) {
  const [loadingProposals, setLoadingProposals] = useState(true)
  const [loadingMetas, setLoadingMetas] = useState(true)
  const [updatedAllProposals, setUpdateAllProposals] = useState(false)

  return (
    <>
      <AnchorsLogoOptions
        anchors={anchors}
        handleSelectAnchor={handleSelectAnchor}
        selectedAnchor={selectedAnchor}
        reloadRightTable={reloadRightTable}
        loadingProposals={loadingProposals}
        loadingMetas={loadingMetas}
        loadingRight={loadingRight}
      />
      <MetasComponent
        selectedAnchor={selectedAnchor}
        updateContent={updateContent}
        setIsLoading={setLoadingMetas}
        isLoading={loadingMetas}
      />
      {boxOperacoes.map((box) => (
        <TableProposals
          key={`${box.boxPropostas}-${box.destinoPagamentoId}`}
          selectedAnchor={selectedAnchor}
          reloadPage={reloadPage}
          updateContent={updateContent}
          updateInfo={updateInfo}
          setUpdateInfo={setUpdateInfo}
          destinoPagamentoId={box.destinoPagamentoId}
          setAtualizaAbatimentoDesconto={setAtualizaAbatimentoDesconto}
          atualizarAbatimentoDesconto={atualizarAbatimentoDesconto}
          setIsLoadingAnchor={setLoadingProposals}
          title={box.titulo}
          boxPropostas={box.boxPropostas}
          mensagemToolTip={box.mensagemToolTip}
          mensagemConfirmacao={box.mensagemConfirmacao}
          tipo={box.tipo}
          originUpdateInfo={box.boxPropostas}
          origin={box.origem}
          updatedAllProposals={updatedAllProposals}
          setUpdateAllProposals={setUpdateAllProposals}
        />        
      ))}
      {/* <ApprovedProposals
        selectedAnchor={selectedAnchor}
        reloadPage={reloadPage}
        updateContent={updateContent}
        updateInfo={updateInfo}
        setUpdateInfo={setUpdateInfo}
        destinoPagamentoId={1}
        setAtualizaAbatimentoDesconto={setAtualizaAbatimentoDesconto}
        atualizarAbatimentoDesconto={atualizarAbatimentoDesconto}
        setIsLoading={setLoadingAprovados}
        isLoading={loadingAprovados}
      />
      <RefusedProposals
        selectedAnchor={selectedAnchor}
        reloadPage={reloadPage}
        updateContent={updateContent}
        updateInfo={updateInfo}
        setUpdateInfo={setUpdateInfo}
        setIsLoading={setLoadingRecusadas}
        isLoading={loadingRecusadas}
      />
      <PendingProposals
        selectedAnchor={selectedAnchor}
        reloadPage={reloadPage}
        updateContent={updateContent}
        updateInfo={updateInfo}
        setUpdateInfo={setUpdateInfo}
        setIsLoading={setLoadingPendentes}
        isLoading={loadingPendentes}
      />
      <ApprovedProposals
        selectedAnchor={selectedAnchor}
        reloadPage={reloadPage}
        updateContent={updateContent}
        updateInfo={updateInfo}
        setUpdateInfo={setUpdateInfo}
        destinoPagamentoId={0}
        setAtualizaAbatimentoDesconto={setAtualizaAbatimentoDesconto}
        atualizarAbatimentoDesconto={atualizarAbatimentoDesconto}
        setIsLoading={setLoadingTerceiros}
        isLoading={loadingTerceiros}
      /> */}
    </>
  );
}

export default OperationsLeftContent;
